import maps from './maps'
import time from './time'
import icons from './icons'
import theme from './theme'
import toolbar from './toolbar'
import locales from './locales'
import analytics from './analytics'
import features from './features'
import currencies from './currencies'
import navigation from './navigation'

export default {
  // product display information
  product: {
    name: 'Enviamas',
    version: '2.0'
  },

  // google maps
  maps,

  // time configs
  time,

  // icon libraries
  icons,

  // theme configs
  theme,

  // toolbar configs
  toolbar,

  // locales configs
  locales,

  // analytics configs
  analytics,

  // feature flags
  features,

  // currencies configs
  currencies,

  // navigation configs
  navigation
}
